import React, { useEffect, useState } from "react";
import { StyleSheet, View, Text, FlatList, Platform } from "react-native";
import moment from "moment";

import { hasItems } from "../../../../helpers/utils";
import EditReflectionGem from "./EditReflectionGem";
import NoJournalEntries from "./NoJournalEntries";
import SearchIcon from "../../common/icons/SearchIcon";
import JournalIcon from "../../common/icons/timeslots/JournalIcon";
import appStyles from "../../../appStyles";
import RoundCheckbox from "../../common/RoundCheckbox";
import AppTheme from "../../AppTheme";

export default function EditReflectionGemsList({
  gems,
  editGemId,
  goal,
  element,
  timeUnit = "week",
  inReportMode = false,
  controller,
  toggleEditMenuOptions = () => {},
  toggleSearch = () => {},
  toggleGemSelection,
}) {
  const [gemsList, setGemsList] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [hasSelectedChildren, setSelectedChildren] = useState(false);

  useEffect(() => {
    setGemsList(getSortedGemsByPeriod(gems, timeUnit));
    _computeAllSelectedState(gems);
  }, [gems]);

  const getSortedGemsByPeriod = (gems, timeUnit) => {
    (gems || []).forEach((g) => {
      const gemDate = moment(g.day);
      g.endDate =
        g.time_unit === "mana" || g.id_element
          ? gemDate
          : gemDate
              .clone()
              .add(1, timeUnit + "s")
              .add(-1, "days");
      g.isFromTrack = g.time_unit === "mana" || g.id_element ? 1 : 2;
    });

    const sortedGems = gems != null ? gems.slice(0) : [];
    sortedGems.sort(function (a, b) {
      // 05.06.2021: First display any existing journal entries on track elements for the time period
      let cmp = a.isFromTrack - b.isFromTrack;
      if (cmp === 0) cmp = -Math.sign(a.endDate.diff(b.endDate), "seconds");
      if (cmp === 0) cmp = a.id - b.id;
      return cmp;
    });

    return sortedGems;
  };

  const toggleAllSelection = (isSelected) => {
    gemsList.forEach((g) => {
      g.isSelected = isSelected;
    });

    setGemsList(gemsList.slice(0));
    setAllSelected(isSelected);
    if (!isSelected) setSelectedChildren(false);

    toggleGemSelection(null, isSelected);
  };

  const toggleSelection = (gemId, isSelected) => {
    toggleGemSelection(gemId, isSelected);
    _computeAllSelectedState(gemsList);
  };

  const _computeAllSelectedState = (gems_list) => {
    if (!hasItems(gems_list)) return;

    const selected = gems_list.filter((g) => g.isSelected).length;

    if (selected == gems_list.length) {
      setAllSelected(true);
      setSelectedChildren(false);
    } else if (selected > 0) {
      setSelectedChildren(true);
    } else {
      setAllSelected(false);
      setSelectedChildren(false);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={styles.header}>
        <View
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            flex: 1,
          }}
        >
         {/*  <JournalIcon
            width={20}
            height={20}
            style={styles.icon}
            fillColor={AppTheme.almostBlack}
          /> */}
          <Text style={styles.journalHeader}>Journal Entries</Text>
        </View>

        {inReportMode ? (
          <RoundCheckbox
            size={16}
            checked={allSelected}
            hasChildrenChecked={hasSelectedChildren}
            onValueChange={toggleAllSelection}
          />
        ) : (
          <SearchIcon onPress={toggleSearch} />
        )}
      </View>

      {hasItems(gemsList) ? (
        <FlatList
          style={[appStyles.scrollView, { paddingHorizontal: 0 }]}
          contentContainerStyle={appStyles.scrollViewContent}
          data={gemsList}
          keyExtractor={(item) => item.gem_id + item.isSelected}
          renderItem={({ item, index }) => (
            <EditReflectionGem
              item={item}
              editGemId={editGemId}
              goal={goal}
              element={element}
              index={index}
              inReportMode={inReportMode}
              openEditMenuOptions={toggleEditMenuOptions}
              toggleGemSelection={inReportMode ? toggleSelection : null}
              controller={controller}
            />
          )}
        />
      ) : !inReportMode ? (
        <NoJournalEntries />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 36,
  },
  journalHeader: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#333333",
    //marginLeft: 6,
  },
  icon: {
    width: 20,
    height: 20,
  },
});
